import type { ValidationIssue } from "@nexxt/contracts";
import { m } from "../paraglide/messages.js";
import { IssueBox } from "./issue-box";

/** A check can name hundreds of rows (a price missing on every line): the first ones say what kind of problem it is. */
const SHOWN_ISSUES = 8;

interface IssueListProps {
  title: string;
  issues: ValidationIssue[];
  /** A problem in the words of its domain: field, rule and row. */
  text: (issue: ValidationIssue) => string;
}

/** What stops an action (422 `details.issues`, or a check before it), problem by problem; nothing without issues. */
export function IssueList({ title, issues, text }: IssueListProps) {
  if (issues.length === 0) return null;
  return (
    <IssueBox title={title}>
      <ul className="mt-1 list-disc pl-5">
        {issues.slice(0, SHOWN_ISSUES).map((issue) => (
          <li key={`${issue.field}-${issue.rule}-${issue.row ?? ""}-${issue.value ?? ""}`}>{text(issue)}</li>
        ))}
      </ul>
      {issues.length > SHOWN_ISSUES && <p className="mt-1">{m.issues_more({ count: issues.length - SHOWN_ISSUES })}</p>}
    </IssueBox>
  );
}
